import { Pencil } from 'lucide-react'
import React from 'react'

interface SuggestEditProps {
  onSuggestEdit?: () => void;
}
function SuggestEdit({ onSuggestEdit }: SuggestEditProps) {
  return (
    <div className='flex items-center'>
        <span onClick={onSuggestEdit} className='inline font-elsm-sans ml-2 text-xs text-gray-700 underline hover:text-gray-900 hover:cursor-pointer'><Pencil className="inline-block mx-1 text-gray-900 " size={16} />Suggest an Edit</span>
    </div>
  )
}

export default SuggestEdit;